import { configureStore } from '@reduxjs/toolkit'
import counterReducer from '../features/counter/counterSlice'
import authReducer from './authSlice'
import notiReducer from './notiSlice'
import deparmentReducer from './departmentSlice'

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    auth: authReducer,
    notification: notiReducer,
    department: deparmentReducer,
  },
})